import { useSSE } from '@app/hooks/useSSE';
import { useAppSelector } from '@app/store/hooks';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

const DRAWER_WIDTH = 260;
const DRAWER_WIDTH_COLLAPSED = 72;

export function AdminLayout() {
	const { sidebarCollapsed } = useAppSelector((state) => state.ui);
	const drawerWidth = sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

	// Connect to SSE for real-time cache invalidation
	useSSE();

	return (
		<Box sx={{ display: 'flex', minHeight: '100vh' }}>
			<Sidebar />
			<Box
				component='main'
				sx={{
					flexGrow: 1,
					width: `calc(100% - ${drawerWidth}px)`,
					transition: 'width 0.2s ease-in-out',
					display: 'flex',
					flexDirection: 'column',
				}}>
				<TopBar />
				<Box
					sx={{
						flexGrow: 1,
						p: 3,
						bgcolor: 'background.default',
						minHeight: 'calc(100vh - 64px)',
					}}>
					<Outlet />
				</Box>
			</Box>
		</Box>
	);
}
